export const ENDPOINTS = {
  AUTH: {
    TOKEN: '/token/',
    REFRESH: '/token/refresh/',
    VERIFY_2FA: '/auth/2fa/verify/',
    PASSWORD_RESET: '/auth/password/reset/',
    PASSWORD_RESET_CONFIRM: '/auth/password/reset/confirm/',
  },
  STRIPE: {
    PRODUCTS: '/stripe/products/',
    CHECKOUT: '/stripe/checkout/',
    BILLING_PORTAL: '/stripe/billing-portal/',
  },
  AFFILIATED_ORGANIZATIONS: {
    LIST: '/affiliated-organizations',
  },
  USERS: {
    ME: '/users/me/',
    CHANGE_PASSWORD: '/users/change-password/',
    TWO_FA_SETUP: '/users/2fa/setup/',
    TWO_FA_ENABLE: '/users/2fa/enable/',
    TWO_FA_DISABLE: '/users/2fa/disable/',
    UPDATE: (id: string) => `/users/${id}/`,
    VERIFY_RPPS: '/users/verify_rpps/',
    CREATE: '/users/',
    VERIFY_EMAIL: '/users/verify_email/',
    VERIFY_ORG_EMAIL: '/users/verify_org_email/',
    PASSWORD_RESET: '/users/password-reset/',
    PASSWORD_RESET_VERIFY: '/users/password-reset-verify/',
    PASSWORD_RESET_CONFIRM: '/users/password-reset-confirm/',
    RESEND_VERIFICATION_EMAIL: '/users/resend_verification_email/',
  },
  ORGANIZATIONS: {
    EXTERNAL_SUBSCRIPTION: (organizationId: string) =>
      `/organizations/${organizationId}/external_subscription/`,
    QUOTE_PDF: (organizationId: string, quoteId: string) =>
      `/organizations/${organizationId}/quote/${quoteId}/pdf/`,
    UPDATE_DESIRED_PRICING: (organizationId: string) =>
      `/organizations/${organizationId}/update_desired_pricing/`,
    INVITE: (organizationId: string) => `/organizations/${organizationId}/invite/`,
    DEACTIVATE_MISTRAL_SEAT: (organizationId: string, userId: string) =>
      `/organizations/${organizationId}/deactivate-mistral-seat/${userId}/`,
    REMOVE_MEMBER: (organizationId: string) => `/organizations/${organizationId}/remove-member/`,
  },
  ORGANIZATION_MEMBERS: {
    LIST: (organizationId: string) => `/organization-members/?organization=${organizationId}`,
  },
  FACILITIES: {
    VERIFY_FINESS: '/facilities/verify_finess/',
  },
  CMS: {
    SCIENTIFIC_CORPORA: '/cms/scientific-corpora/',
    TEAM_MEMBERS: '/cms/team-members/',
    TEAM_CATEGORIES: '/cms/team-categories/',
    FAQ: '/cms/faq/',
  },
} as const
